var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSchedulet1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M7.003 12.806a5.445 5.445 0 1 0 0-10.889 5.445 5.445 0 0 0 0 10.89z",
    fill: "#979797"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.535 7.625c0 .258.214.471.471.471h3.148a.474.474 0 0 0 .47-.47.474.474 0 0 0-.47-.472H7.477V4.486a.474.474 0 0 0-.47-.471.474.474 0 0 0-.472.47v3.14z",
    fill: "#979797"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.86 1.814 2.767 3.023c-.145.083-.361-.024-.487-.241-.126-.218-.113-.464.032-.548l2.093-1.209c.145-.083.361.024.487.241.126.218.113.464-.032.548zM11.242 3.025l-2.096-1.21C9 1.73 8.985 1.49 9.11 1.271c.125-.218.345-.33.49-.246l2.096 1.21c.145.084.16.325.035.542-.125.218-.345.33-.49.247z",
    fill: "#979797"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchedulet1);
export default __webpack_public_path__ + "static/media/schedulet1.015b9a5fb13a9631b2e84ebcee8c2845.svg";
export { ForwardRef as ReactComponent };